import {
  Button,
  DrawerClose,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from '@e2n/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { useUpdateTerminKalenderFormContext } from '@/domain/termine/features/UpdateTerminkalender/shared';

export function UpdateTerminKalenderDrawerHeader() {
  const form = useUpdateTerminKalenderFormContext();
  const { t } = useTranslation();

  return (
    <DrawerHeader
      className={cn(
        'sticky top-0 z-10 h-14 shrink-0',
        'border-b border-neutrals-300 bg-neutrals-200 py-2 px-4',
      )}>
      <DrawerTitle className="flex items-center justify-between">
        <div className="flex items-center">
          <DrawerClose asChild>
            <Button
              variant="ghost"
              size="icon"
              className="hover:bg-transparent">
              <FontAwesomeIcon icon={faArrowLeft} fixedWidth />
            </Button>
          </DrawerClose>
          <span className="text-sm text-neutrals-800">
            {t('domain.termine.kalender.form.kalenderBearbeiten')}
          </span>
        </div>
        <form.SubmitButton
          variant="ghost-primary"
          buttonText={t('domain.termine.form.fertig')}
        />
      </DrawerTitle>
      <DrawerDescription className="sr-only">
        {t('domain.termine.kalender.form.kalenderBearbeiten')}
      </DrawerDescription>
    </DrawerHeader>
  );
}
